import {
  AcademicCapIcon,
  Battery100Icon,
  HeartIcon,
  SpeakerXMarkIcon
} from '@heroicons/react/24/outline'

import { pv, stagger } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import { MaskText } from '../../stage/fx'

export const TIPS_PARTICLES = [
  [0.04, () => ({ type: 'scatter', alpha: 0.3, seed: 67 })],
  [0.5, () => ({ type: 'frame', inset: 26 })],
  [1, () => ({ type: 'frame', inset: 26 })]
]

const LOOK = [
  { Icon: SpeakerXMarkIcon, tone: '#8FB0FF', rot: -14 },
  { Icon: Battery100Icon, tone: '#43DBBD', rot: 8 },
  { Icon: HeartIcon, tone: '#FE79A7', rot: -5 },
  { Icon: AcademicCapIcon, tone: '#FFB628', rot: 12 }
]

// Vier Karten fliegen als Stapel ein, drehen sich um und werden nebeneinander ausgeteilt
export default function CsTips() {
  const c = useCopy('tipps')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <div className='cs-tips-head'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {s.tipsKicker}
        </Line>
        <h2 className='sc-h2'>
          <MaskText text={c.title} at={[0.02, 0.12]} />
        </h2>
      </div>

      <div className='cs-deck'>
        {c.tips.map((t, i) => {
          const { Icon, tone, rot } = LOOK[i]
          return (
            <article
              key={t.title}
              className={`cs-tip cs-tip--${i}`}
              style={{
                ...pv('e', [0.08, 0.18]),
                ...pv('d', stagger(0.22, 0.1, 0.16, i)),
                '--r': `${rot}deg`,
                '--tone': tone
              }}
            >
              <div className='cs-tip__inner'>
                <div className='cs-tip__back' aria-hidden='true'>
                  <span>Aivy</span>
                </div>
                <div className='cs-tip__front'>
                  <Icon className='cs-tip__icon' />
                  <h3 className='sc-h3'>{t.title}</h3>
                  <p>{t.text}</p>
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </div>
  )
}
